import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Zap, Lock } from 'lucide-react';

const FlowRow = ({ flow, idx }) => {
  const isBullish = flow.type === 'CALL';
  const tone = isBullish ? 'green' : 'red';
  return (
    <div
      className={`p-2.5 rounded-lg border bg-${tone}-50 border-${tone}-200`}
      data-testid={`options-flow-item-${idx}`}
    >
      <div className="flex justify-between items-center text-sm">
        <span className={`font-medium text-${tone}-700`}>
          {flow.type} {flow.sentiment ? `(${flow.sentiment})` : ''}
        </span>
        <span className={`text-${tone}-700`}>
          {flow.premium_display || `$${(flow.premium || 0).toLocaleString()}`}
        </span>
      </div>
      <p className={`text-xs text-${tone}-600`}>
        {flow.expiry} ${flow.strike} • Vol/OI {flow.vol_oi_ratio?.toFixed?.(1) || 'n/a'}×
      </p>
    </div>
  );
};

const UnusualOptionsCard = ({ optionsFlow, stockData, isPro }) => (
  <Card
    className={`hover:shadow-lg transition-shadow ${!isPro ? 'opacity-75' : ''}`}
    data-testid="research-options-flow-card"
  >
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-lg">
        <Zap className="text-purple-600" size={20} />
        Unusual Options
        {!isPro && <Lock size={14} className="text-gray-400" />}
      </CardTitle>
    </CardHeader>
    <CardContent>
      {!isPro ? (
        <div className="text-center py-4">
          <Lock className="mx-auto mb-2 text-gray-400" size={24} />
          <p className="text-gray-500 text-sm">Upgrade to Pro to unlock</p>
        </div>
      ) : optionsFlow?.flows?.length ? (
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {optionsFlow.flows.slice(0, 6).map((f, idx) => (
            <FlowRow key={`${f.type}-${f.strike}-${f.expiry}-${idx}`} flow={f} idx={idx} />
          ))}
          {optionsFlow.summary && (
            <p className="text-xs text-gray-500 pt-2 border-t">{optionsFlow.summary}</p>
          )}
        </div>
      ) : stockData ? (
        <p className="text-gray-500 text-sm text-center py-4">
          No unusual options activity detected for {stockData.symbol}
        </p>
      ) : (
        <p className="text-gray-500 text-sm">Search for a stock to see options flow</p>
      )}
    </CardContent>
  </Card>
);

export default UnusualOptionsCard;
